import o from "./CdrPopup.vue2.mjs";
import s from "./styles/CdrPopup.module.scss.mjs";
import t from "../../_virtual/_plugin-vue_export-helper.mjs";
const r = {
  $style: s
}, c = /* @__PURE__ */ t(o, [["__cssModules", r]]);
export {
  c as default
};
